export const toBoolean = (value?: string | boolean): boolean => {
  if (!value) {
    return false;
  }

  if (typeof value === 'boolean') {
    return value;
  }

  return value.toLowerCase() === "true";
};
